import { css } from '@emotion/react';
import { flex } from '../../styles/utils';
import { ZeeFontBold, ZeeFontRegular } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { colors } from '../../styles/colors';

export const gameLandingContainerStyle = css`
  position: relative;
  width: 100%;
  min-height: calc(100vh - 108px);
  ${MQ.MediaMd} {
    min-height: calc(100vh - 80px);
  }
`;

export const bannerBgImgStyle = css`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
`;
export const containerOverlayStyle = css`
  position: absolute;
  width: 100%;
  min-height: 100%;
  ${flex('column', 'space-between')}
`;
export const headerContainerStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  ${MQ.MediaMd} {
    padding: 42px;
  }
`;
export const headerGameLogoStyle = css`
  width: 78px;
  ${MQ.MediaMd} {
    width: 106px;
  }
`;
export const headerTournamentLogoStyle = css`
  width: 85px;
  margin-left: auto;
  ${MQ.MediaMd} {
    width: 120px;
  }
`;

export const mainContainerStyle = css`
  margin-top: auto;
  ${flex('column', 'center', 'center')}
  gap: 24px;
  text-align: center;
  padding: 24px;
`;
export const titleStyle = css`
  ${ZeeFontBold(40, 36)};
  font-weight: 900;
  width: 70%;
  font-style: italic;
  color: ${colors.PrimaryWhiteColor};
  ${MQ.MediaMd} {
    ${ZeeFontBold(56, 49)};
  }
`;
export const gameInstructionTextStyle = css`
  ${ZeeFontBold(14, 20)};
  color: ${colors.PrimaryWhiteColor};
  ${MQ.MediaMd} {
    ${ZeeFontBold(16, 22)};
  }
`;

export const sponserTextStyle = css`
  color: ${colors.PrimaryWhiteColor};
`;

export const sponserLogoStyle = css`
  width: 100%;
  object-fit: contain;
`;

export const sponserWrapperStyle = css`
  display: flex;
  gap: 4px;

  & p {
    ${ZeeFontRegular(10, 22)};
  }

  & img {
    width: 125px;
  }
`;

export const checkboxContainerStyle = css`
  gap: 8px;
  width: 100%;
  ${flex('row', 'center', 'center')}
`;

export const checkboxStyle = css`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const checkboxDescriptionStyle = css`
  color: ${colors.FeatureGrey};
  ${ZeeFontRegular(10, 14)};
  ${MQ.MediaMd} {
    ${ZeeFontRegular(14, 20)};
  }
`;

export const linkStyle = css`
  text-transform: capitalize;
  ${ZeeFontBold(10, 14)};
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  ${MQ.MediaMd} {
    ${ZeeFontRegular(14, 20)};
  }
`;

export const gameCtaContainerStyle = css`
  ${flex('row', 'center', 'center')};
  width: 100%;
  gap: 18px;
`;

export const howToPlayLinkStyle = css`
  ${flex('row', 'center', 'center')};
  gap: 4px;
  padding: 8px 24px;
  width: 100%;
  ${ZeeFontBold(12, 18)}
  color: ${colors.PrimaryWhiteColor};
`;

export const ctaStyle = css`
  ${flex('row', 'center', 'center')}
  gap: 4px;
  padding: 8px 0;
  width: calc(100% - 64px);
  margin: 0 32px;
  color: ${colors.PrimaryWhiteColor};
  border-radius: 2px;
  border: 1px solid ${colors.PrimaryWhiteColor};
  cursor: pointer;
  background-color: ${colors.DarkSlate};
  ${ZeeFontBold(12, 18)}
`;

export const ctaDisabledStyle = css`
  border: 1px solid ${colors.DustyMauve};
  pointer-events: none;
  background-color: ${colors.DeepCharcoal};
  color: ${colors.DustyMauve};
`;
